import { useEffect, useState } from 'react';
import api from '~/lib/api';
import type { Mcc, UseMccsResult } from './types';

function useMccs(): UseMccsResult {
  const [mccs, setMccs] = useState<Mcc[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    api.get('/networks/mccs').then(response => {
      const mccsData: string[] = response.data;
      setMccs(mccsData.map(mcc => ({ label: mcc, value: mcc })));
      setLoading(false);
    });
  }, []);

  return { mccs, loading };
}

export default useMccs;
